/*eslint-disable */
import { PORTAL_APP_SUBSCRIPTION_PATH } from '@zopup/zop-shared';
import { ZopNavigationItem } from '@zopup/zop-ux-core';
import type Keycloak from 'keycloak-js';

export const defaultNavigation = (keycloak: Keycloak): ZopNavigationItem[] => [
    {
        id: 'home',
        title: 'navigation.home',
        type: 'basic',
        icon: 'lucide-house',
        link: '/home',
    },
    {
        id: 'task-board',
        title: 'navigation.task-board',
        tooltip: 'navigation.task-board',
        type: 'basic',
        icon: 'lucide-columns-3',
        link: '/task-boards',
    },
    {
        id: 'dashboard',
        title: 'navigation.dashboard',
        tooltip: 'navigation.dashboard',
        type: 'basic',
        icon: 'lucide-presentation',
        link: '/dashboards',
    },
    {
        id: 'timeline',
        title: 'navigation.timeline',
        tooltip: 'navigation.timeline',
        type: 'basic',
        icon: 'lucide-clock',
        link: '/audit-log',
    },
    {
        id: 'assets',
        title: 'navigation.assets',
        tooltip: 'navigation.assets',
        type: 'collapsable',
        icon: 'lucide-package',
        children: [
            {
                id: 'assets.items',
                title: 'navigation.assets.items',
                type: 'basic',
                icon: 'lucide-box',
                link: '/inventory/items',
            },
            {
                id: 'assets.assets',
                title: 'navigation.assets.assets',
                type: 'basic',
                icon: 'lucide-package',
                link: '/assets',
            },
            {
                id: 'assets.tracking',
                title: 'navigation.assets.tracking',
                type: 'basic',
                icon: 'lucide-map-pin',
                link: '/assets/tracking',
            },
            {
                id: 'assets.vouchers',
                title: 'navigation.assets.vouchers',
                type: 'basic',
                icon: 'lucide-receipt-text',
                link: '/inventory/vouchers',
            },
            {
                id: 'assets.movements',
                title: 'navigation.assets.movements',
                type: 'basic',
                icon: 'lucide-arrow-right-left',
                link: '/inventory/movements',
            },
        ],
    },
    {
        id: 'work-management',
        title: 'navigation.work-management',
        tooltip: 'navigation.work-management',
        type: 'collapsable',
        icon: 'lucide-toolbox',
        children: [
            {
                id: 'work-management.schedules',
                title: 'navigation.work-management.schedules',
                type: 'basic',
                icon: 'lucide-calendar-sync',
                link: '/work-management/schedules',
            },
            {
                id: 'work-management.work-plans',
                title: 'navigation.work-management.work-plans',
                type: 'basic',
                icon: 'lucide-calendar-check',
                link: '/work-management/work-plans',
            },
            {
                id: 'work-management.work-definitions',
                title: 'navigation.work-management.work-definitions',
                type: 'basic',
                icon: 'lucide-file-text',
                link: '/work-management/work-definitions',
            },
            {
                id: 'work-management.bom',
                title: 'navigation.work-management.bom',
                type: 'basic',
                icon: 'lucide-layers-3',
                link: '/work-management/bom',
            },
            {
                id: 'work-management.material-requirements',
                title: 'navigation.work-management.material-requirements',
                type: 'basic',
                icon: 'lucide-package-search',
                link: '/work-management/material-requirements',
            },
            {
                id: 'work-management.work-orders',
                title: 'navigation.work-management.work-orders',
                type: 'basic',
                icon: 'lucide-factory',
                link: '/work-management/work-orders',
            },
        ],
    },
    {
        id: 'purchase',
        title: 'navigation.purchase',
        tooltip: 'navigation.purchase',
        type: 'collapsable',
        hidden: () => false,
        icon: 'lucide-shopping-bag',
        children: [
            {
                id: 'purchase.vendors',
                title: 'navigation.purchase.vendors',
                type: 'basic',
                icon: 'lucide-users',
                link: '/purchase/vendors',
            },
            {
                id: 'purchase.orders',
                title: 'navigation.purchase.orders',
                type: 'basic',
                icon: 'lucide-library-big',
                link: '/purchase/orders',
            },
            {
                id: 'purchase.goods-receipt-notes',
                title: 'navigation.purchase.goods-receipt-notes',
                type: 'basic',
                icon: 'lucide-truck',
                link: '/purchase/goods-receipt-notes',
            },
            {
                id: 'purchase.bills',
                title: 'navigation.purchase.bills',
                type: 'basic',
                icon: 'lucide-receipt',
                link: '/purchase/bills',
            },
            {
                id: 'purchase.returns',
                title: 'navigation.purchase.returns',
                type: 'basic',
                icon: 'lucide-undo-2',
                link: '/purchase/returns',
            },
        ],
    },
    {
        id: 'projects',
        title: 'navigation.projects',
        tooltip: 'navigation.projects',
        type: 'basic',
        icon: 'lucide-folder-kanban',
        link: '/projects',
    },
      {
        id: 'verified',
        title: 'navigation.verified',
        tooltip: 'navigation.verified',
        type: 'collapsable',
        hidden: () => false,
        icon: 'lucide-badge-check',
        children: [
            {
                id: 'verified.scans',
                title: 'navigation.verified.scans',
                type: 'basic',
                icon: 'lucide-qr-code',
                link: '/verified/scans',
            },
            {
                id: 'verified.issues',
                title: 'navigation.verified.issues',
                type: 'basic',
                icon: 'lucide-alert-circle',
                link: '/verified/issues',
            }
        ],
    },
    {
        id: 'reports',
        title: 'navigation.reports',
        tooltip: 'navigation.reports',
        type: 'basic',
        icon: 'lucide-file-chart-column',
        link: '/reports',
    },
    {
        id: 'documents',
        title: 'navigation.documents',
        tooltip: 'navigation.documents',
        type: 'basic',
        icon: 'lucide-folders',
        link: '/documents',
    },
    {
        id: 'alerts',
        title: 'navigation.alerts',
        tooltip: 'navigation.alerts',
        type: 'basic',
        icon: 'lucide-bell-ring',
        link: '/alerts',
    },
    {
        id: 'divider-1',
        type: 'divider',
    },
    {
        id: 'settings',
        title: 'navigation.settings',
        subtitle: '',
        type: 'basic',
        icon: 'lucide-settings',
        link: '/settings',
    },
    {
        id: 'user.profile',
        title: 'navigation.user.profile',
        subtitle: '',
        type: 'basic',
        icon: 'lucide-user-circle',
        link: '/user/profile',
    },
    {
        id: 'subscription',
        title: 'navigation.subscription',
        subtitle: '',
        type: 'basic',
        icon: 'lucide-credit-card',
        function: () => {
            window.open(PORTAL_APP_SUBSCRIPTION_PATH);
        },
    },
    {
        id: 'tenant.account',
        title: 'navigation.tenant.account',
        subtitle: 'navigation.selected-account',
        type: 'basic',
        icon: 'lucide-building',
        link: '/tenant-selection',
    },
    {
        id: 'tenant.branches',
        title: 'navigation.tenant.branches',
        subtitle: 'navigation.selected-branch',
        type: 'basic',
        icon: 'lucide-building-2',
        link: '/branch-selection',
    },
    {
        id: 'help-center',
        title: 'navigation.help-center',
        tooltip: 'navigation.help-center',
        type: 'basic',
        icon: 'lucide-help-circle',
        link: '/help-center',
    },
    {
        id: 'user.signout',
        title: 'navigation.user.signout',
        subtitle: '',
        type: 'basic',
        icon: 'lucide-log-out',
        function: async () => {
            await keycloak.logout({
                redirectUri: window.location.origin + '/sign-in',
            });
        },
    },
    {
        id: 'changelog',
        title: 'navigation.changelog',
        tooltip: 'navigation.changelog',
        type: 'basic',
        icon: 'lucide-megaphone',
        link: '/changelog',
        badge: {
            title: '0.1.0',
            classes: 'px-2 bg-yellow-300 text-black rounded-full',
        },
    },
];
export const compactNavigation: ZopNavigationItem[] = [
    {
        id: 'home',
        title: 'navigation.home',
        type: 'basic',
        icon: 'lucide-home',
        link: '/home',
    },
    {
        id: 'task-board',
        title: 'navigation.task-board',
        tooltip: 'navigation.task-board',
        type: 'basic',
        icon: 'lucide-columns-3',
        link: '/task-board',
    },
    {
        id: 'timeline',
        title: 'navigation.timeline',
        tooltip: 'navigation.timeline',
        type: 'basic',
        icon: 'lucide-clock',
        link: '/audit-log',
    },
    {
        id: 'contacts',
        title: 'navigation.contacts',
        tooltip: 'navigation.contacts',
        type: 'basic',
        icon: 'lucide-users-2',
        link: '/contacts',
    },
    {
        id: 'finance',
        title: 'navigation.finance',
        tooltip: 'navigation.finance',
        type: 'aside',
        icon: 'lucide-banknote',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'inventory',
        title: 'navigation.inventory',
        tooltip: 'navigation.inventory',
        type: 'aside',
        icon: 'lucide-box',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'sales',
        title: 'navigation.sales',
        tooltip: 'navigation.sales',
        type: 'aside',
        icon: 'lucide-shopping-cart',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'purchase',
        title: 'navigation.purchase',
        tooltip: 'navigation.purchase',
        type: 'aside',
        icon: 'lucide-shopping-bag',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'reports',
        title: 'navigation.reports',
        tooltip: 'navigation.reports',
        type: 'basic',
        icon: 'lucide-bar-chart-2',
        link: '/reports',
    },
    {
        id: 'documents',
        title: 'navigation.documents',
        tooltip: 'navigation.documents',
        type: 'basic',
        icon: 'lucide-folders',
        link: '/documents',
    },
    {
        id: 'divider-1',
        type: 'divider',
    },
    {
        id: 'changelog',
        title: 'navigation.changelog',
        tooltip: 'navigation.changelog',
        type: 'basic',
        icon: 'lucide-megaphone',
        link: '/changelog',
    },
    {
        id: 'settings',
        title: 'navigation.settings',
        tooltip: 'navigation.settings',
        type: 'basic',
        icon: 'lucide-settings',
        link: '/settings',
    },
    {
        id: 'help-center',
        title: 'navigation.help-center',
        tooltip: 'navigation.help-center',
        type: 'basic',
        icon: 'lucide-help-circle',
        link: '/help-center',
    },
    {
        id: 'user',
        title: 'navigation.user',
        subtitle: '',
        type: 'aside',
        icon: 'lucide-user-circle',
    },
    {
        id: 'tenant.account',
        title: 'navigation.tenant.account',
        subtitle: 'navigation.selected-account',
        type: 'basic',
        icon: 'lucide-building',
        link: '/finance/accounts',
    },
    {
        id: 'tenant.branches',
        title: 'navigation.tenant.branches',
        subtitle: 'navigation.selected-branch',
        type: 'basic',
        icon: 'lucide-building-2',
        link: '/finance/account-ledgers',
    },
];
export const futuristicNavigation: ZopNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'DASHBOARDS',
        type: 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'APPS',
        type: 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'others',
        title: 'OTHERS',
        type: 'group',
    },
    {
        id: 'pages',
        title: 'Pages',
        type: 'aside',
        icon: 'lucide-copy',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'User Interface',
        type: 'aside',
        icon: 'lucide-layers-2',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Navigation Features',
        type: 'aside',
        icon: 'lucide-menu',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
export const horizontalNavigation: ZopNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        type: 'group',
        icon: 'lucide-home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'Apps',
        type: 'group',
        icon: 'lucide-qr-code',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'pages',
        title: 'Pages',
        type: 'group',
        icon: 'lucide-copy',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'UI',
        type: 'group',
        icon: 'lucide-layers-2',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Misc',
        type: 'group',
        icon: 'lucide-menu',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
